import { render, staticRenderFns } from "./TabMain.vue?vue&type=template&id=f2e1329e"
import script from "./TabMain.vue?vue&type=script&lang=ts"
export * from "./TabMain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports